module.exports = __webpack_public_path__ + "img/family-12.0692ca71.jpg";